import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Table, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import SidebarLayout from "../components/shared/SidebarLayout";
import { useTranslation } from "react-i18next";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import PhoneInput from "react-phone-input-2";
import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "lodash";
const Profile = () => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const getProfileData = useContextSelector(
    AuthContext,
    (ctx) => ctx.getProfileData,
  );
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const sendMobileOTP = useContextSelector(
    AuthContext,
    (ctx) => ctx.sendMobileOTP,
  );
  const setSeconds = useContextSelector(AuthContext, (ctx) => ctx.setSeconds);
  const setMinutes = useContextSelector(AuthContext, (ctx) => ctx.setMinutes);
  const seconds = useContextSelector(AuthContext, (ctx) => ctx.seconds);
  const minutes = useContextSelector(AuthContext, (ctx) => ctx.minutes);
  const getSendOtpStatus = useContextSelector(
    AuthContext,
    (ctx) => ctx.getSendOtpStatus,
  );
  const setSendOtpStatus = useContextSelector(
    AuthContext,
    (ctx) => ctx.setSendOtpStatus,
  );
  const { t } = useTranslation();
  const [edit, setEdit] = useState({});
  const [verifyEdit, setVerifyEdit] = useState({});
  const [verify, setVerify] = useState({});
  const [getMobileNumber, setMobileNumber] = useState({});
  console.log(getMobileNumber);
  const handleCloseVerify = () => {
    setVerifyEdit({ status: false });
  };
  const handleClose = () => {
    setEdit({ status: false });
  };
  const [select, setSelect] = useState({
    type: "",
    title: "",
    status: false,
  });
  const today = new Date().toISOString().split("T")[0];
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      countryCode: 91,
      uniqueId: Math.random() * 10000,
    },
  });
  useEffect(() => {
    setValue("verificationCode", "");
  }, [verifyEdit]);

  const onSubmit = async (body) => {
    const { status, data: response_users1 } = await apiPost(
      apiPath.userProfileUpdate,
      select?.type == "birthday"
        ? { dob: body?.dob }
        : select?.type == "fullname"
          ? {
              fullName: body?.username,
            }
          : { email: body?.email },
    );
    if (status === 200) {
      if (response_users1.success) {
        toast.success(response_users1?.message);
        setSelect({});
        getProfileData();
      } else {
        toast.error(response_users1?.message);
      }
    } else {
      toast.error(response_users1?.message);
    }
  };
  const [isLoader, setLoader] = useState(false);
  const onSubmit1 = async (body) => {
    setLoader(true);
    const { status, data } = await apiPost(apiPath.verifyOtpNew, {
      new_phone_number: body?.mobile,
      phone_number: profileData?.phone,
      type: "password",
      password: body?.verificationCode,
    });
    if (status === 200) {
      if (data.success) {
        toast.success(data?.message);
        setLoader(false);
        handleCloseVerify();
        getProfileData();
        setSelect({});
        reset();
      } else {
        setLoader(false);
        toast.error(data?.message);
      }
    } else {
      setLoader(false);
      toast.error(data?.message);
    }
  };
  return (
    <SidebarLayout heading={t("My_Profile")}>
      {" "}
      <div className="p-sm-3 p-2 inner-sidebar-content">
        <Table className="align-middle bg-white">
          <tbody>
            <tr>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
                {t("User_Name")}
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="40%">
                {profileData?.firstName}
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
                {" "}
                <Button
                  onClick={() =>
                    setSelect({
                      type: "fullname",
                      title: "Add Full Name",
                      placeholder: "Your full name ...",
                      label: "Full Name",
                      status: true,
                    })
                  }
                  className="theme-btn py-1 px-3 fs-6"
                >
                  {t("Edit")}
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
                {t("Email")}
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="40%">
                {profileData?.email || "-"}
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
                {" "}
                <Button
                  onClick={() =>
                    setSelect({
                      type: "email",
                      title: "Add Email",
                      placeholder: "Your email address ...",
                      label: "Email",
                      status: true,
                    })
                  }
                  className="theme-btn py-1 px-3 fs-6"
                >
                  {t("Edit")}
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
                Password
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="40%">
                ********
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
                <Button
                  onClick={() => navigate("/reset-password")}
                  className="theme-btn py-1 px-3 fs-6"
                >
                  {t("Edit")}
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
                Mobile
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="40%">
                {profileData?.phone} <br />
                {profileData?.temporaryPhone}
              </td>
              <td style={{ padding: "4px", fontSize: "13px" }} width="30%">
              
                  <Button
                    onClick={() =>
                      setVerifyEdit({
                        ...verifyEdit,
                        status: true,
                        phoneStatus: "add",
                        item: profileData?.phone,
                      })
                    }
                    className="theme-btn py-1 px-1 fs-3"
                  >
                    {"Edit"}
                  </Button>
           
                {/* {profileData?.phone != 0 ? (
                  <>
                    {profileData?.isVerified == false ? (
                      <Button
                        onClick={() => {
                          setVerifyEdit({
                            ...verifyEdit,
                            status: true,
                            item: profileData?.phone,
                          });
                          sendMobileOTP("first", profileData?.phone);
                        }}
                        className="theme-btn py-1 px-3 fs-6"
                      >
                        {"Verify"}
                      </Button>
                    ) : (
                      <span style={{ color: `green`, fontWeight: `600` }}>
                        Verified
                      </span>
                    )}
                  </>
                ) : (
                  <Button
                    onClick={() =>
                      setVerifyEdit({
                        ...verifyEdit,
                        status: true,
                        phoneStatus: "add",
                        item: profileData?.phone,
                      })
                    }
                    className="theme-btn py-1 px-3 fs-6"
                  >
                    {"Add Phone"}
                  </Button>
                )} */}
              </td>
            </tr>
            <tr></tr>

            {/* <tr>
              <td width="30%">{t("Password")}</td>
              <td width="40%">********</td> 
            <td width="30%">
                <Button
                  onClick={() => navigate("/change-password")}
                  className="theme-btn py-1 px-3 fs-6"
                >
                  {t("Edit")}
                </Button>
              </td> 
             </tr> */}
          </tbody>
        </Table>
      </div>
      {select?.status && (
        <Modal
          className="mobile-verify-div"
          centered
          show={select?.status}
          onHide={() => setSelect({ status: false })}
        >
          <Modal.Header style={{padding:"10px"}} closeButton>
            <Modal.Title>{select?.label}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body>
              <Form.Group className="d-flex">
                <Form.Control
                  type={select?.type == "birthday" ? "date" : "text"}
                  placeholder={select?.placeholder}
                  {...register(
                    select?.type === "birthday"
                      ? "dob"
                      : select?.type === "fullname"
                        ? "username"
                        : "email",
                    select?.type === "birthday"
                      ? {
                          required: "Date of birth is required",
                          validate: (v) =>
                            v <= today || "Date must be in the past",
                        }
                      : select?.type === "fullname"
                        ? {
                            required: t("Enter_Valid_Username"),
                            validate: {
                              noLeadingSpaces: (value) =>
                                !/^\s/.test(value) || t("Enter_Valid_Username"),
                              noTrailingSpaces: (value) =>
                                !/\s$/.test(value) || t("Enter_Valid_Username"),
                              alphanumericOnly: (value) =>
                                /^[a-zA-Z0-9 ]*$/.test(value) ||
                                t("Only_Alphabets_And_Numbers_Allowed"),
                              noOnlySpaces: (value) =>
                                value.trim().length > 0 ||
                                t("Enter_Valid_Username"),
                              mustContainAlphabet: (value) =>
                                /[a-zA-Z]/.test(value) ||
                                t("Username_Must_Contain_At_Least_One_Letter"),
                              minLength: (value) =>
                                value.trim().length >= 3 || t("Min3User"),
                              maxLength: (value) =>
                                value.trim().length <= 30 || t("Max30User"),
                            },
                          }
                        : {
                            required: t("Pleaseenteremail"),
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                              message: t("Invalidemailaddress"),
                            },
                          },
                  )}
                />
              </Form.Group>

              {!isEmpty(errors?.email?.message) && (
                <div class="alert ">{errors?.email?.message}</div>
              )}
              {!isEmpty(errors?.username?.message) && (
                <div class="alert ">{errors?.username?.message}</div>
              )}
              {!isEmpty(errors?.dob?.message) && (
                <div class="alert ">{errors?.dob?.message}</div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button className="submit-btn" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
      {verifyEdit?.status && (
        <Modal
          centered
          show={verifyEdit?.status}
          onHide={handleCloseVerify}
          className="mobile-verify-div"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Phone</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit(onSubmit1)}>
            <Modal.Body>
              <Form.Group className="form-group d-flex  mb-1">
                <Controller
                  className="form-group d-flex"
                  control={control}
                  name="mobile"
                  rules={{
                    required: "Please enter mobile number.",
                    validate: (value) => {
                      let inputValue = value
                        ?.toString()
                        ?.slice(
                          inputRef?.current?.state?.selectedCountry?.countryCode
                            ?.length,
                          value?.length,
                        );
                      if (inputValue?.length < 10) {
                        return "Mobile number must contain 10 digit";
                      } else if (inputValue?.length > 12) {
                        return "Mobile number should not exceed 12 digit";
                      } else {
                        return true;
                      }
                    },
                  }}
                  render={({ field: { ref, ...field } }) => (
                    <>
                      <PhoneInput
                        {...field}
                        inputExtraProps={{
                          ref,
                          required: true,
                          autoFocus: true,
                        }}
                        ref={inputRef}
                        inputStyle={{
                          width: "100%",
                          height: "38px",
                        }}
                        country={"bd"}
                        enableSearch
                        countryCodeEditable={false}
                      />
                    </>
                  )}
                />
              </Form.Group>
              {errors?.mobile?.message && (
                <div className="text-danger">{errors?.mobile?.message}</div>
              )}

              <Form.Group className="d-flex">
                <div
                  style={{ position: "relative", width: `100%` }}
                  className="mb-1"
                >
                  <Form.Control
                    type="text"
                    placeholder="Enter Password"
                    className={errors.verificationCode ? " is-invalid " : ""}
                    {...register("verificationCode", {
                      required: "Please enter password",
                    })}
                  />
                </div>
              </Form.Group>

              {errors?.verificationCode?.message && (
                <div className="text-danger">
                  {errors?.verificationCode?.message}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <button
                type="submit"
                className="submit-btn"
                disabled={isLoader ? "disabled" : ""}
              >
                <span> {isLoader ? "Loading..." : t("Confirm")}</span>
              </button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </SidebarLayout>
  );
};

export default Profile;
